<div class="limiter animated fadeIn">
    <div class="container-login100">
        <div class="wrap-login100 p-t-20 pb-5" style="width:300px; min-width: 300px; top: -50px">
            <form 
                (ngSubmit)="login(frm)"  #frm="ngForm"
                class="login100-form validate-form flex-sb flex-w">

                <span class="login100-form-title p-b-51 titol-navbar">
                    Gestió IT Àmbit Hospitalari
                </span>

                <span class="text pb-1">
                    Introdueix l'usuari i la clau
                </span>

                <span 
                    *ngIf="frm.submitted && frm.controls['id'].errors" 
                    class="text-danger animated fadeIn">L'usuari es obligatori</span>
                <div class="wrap-input100 m-b-16">
                    <input class="input100" 
                           type="text" 
                           name="id" 
                           [(ngModel)]="usuari.id"
                           required
                           placeholder="Id usuari">
                    <span class="focus-input100"></span>
                </div>
                
                <span 
                    *ngIf="frm.submitted && frm.controls['password'].errors" 
                    class="text-danger animated fadeIn">La password es obligatoria</span>
                <div class="wrap-input100 m-b-16">
                    <input class="input100"
                           type="password" 
                           name="password"
                           required
                           [(ngModel)]="usuari.password"
                           placeholder="Password">
                    <span class="focus-input100"></span>
                </div>
                
                <!-- <div class="flex-sb-m w-full p-t-3 p-b-24">
                    <div class="contact100-form-checkbox">
                        <input 
                            [(ngModel)]="recordar"
                            class="input-checkbox100" id="ckb1" type="checkbox" name="remember-me">
                        <label class="label-checkbox100" for="ckb1">
                            Recordar el meu usuari
                        </label>
                    </div>
                    <div>
                        <a routerLink="/registre" class="txt1">
                            ¿No estàs registrat?
                        </a>
                    </div>
                </div> -->

                <div class="container-login100-form-btn m-t-17">
                    <button class="login100-form-btn" type="submit">
                        Entrar
                    </button>
                </div>
            </form>

        </div>
    </div>
</div>
